export enum ETimeSlot {
    None = 1,
    Morning = 2,
    Afternoon = 3
}